export const PERIOD_FLAG_LITERAL_ID = 'period_flag';
export const METRIC_NAME_STATUS_LITERAL_ID = 'metric_name_status';
export const BENCHMARK_INDUSTRY_FLAG_LITERAL_ID = 'benchmark_industry_flag';
